class File {
	constructor(obj) {
		let btn = obj.find('.file-btn'),
			input = obj.find('.file-input'),
			value = obj.find('.file-value');
		
		input.change(() => {
			value.text(input.val().replace(/^.*([\/\\])([\w.]+)$/, '$2'));
		});
		
		btn.click((e) => {
			e.preventDefault();
			input.click();
		});
	}
}

$(() => {
	$(".file").each(function () {
		new File($(this));
	});
});